import Splide from '@splidejs/splide';

const mountInstallSlider = (el) => {
  new Splide(el, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: false,
    pagination: true,
    classes: {
      pagination:
        'splide__pagination product-dimmer-switch-where-to-install__slider-pagination',
      page: 'splide__pagination__page product-dimmer-switch-where-to-install__slider-pagination-btn',
    },
  }).mount();
};

export const initDimmerSwitchWhereToInstallSlider = () => {
  const stepsSlider = document.querySelector(
    '[data-product-dimmer-switch-where-to-install-slider]'
  );

  mountInstallSlider(stepsSlider);
};
